<template>
  <div >
    <!-- <my-header :menuIndex="0"></my-header> -->
    <div v-show="isShowYuyue" class="yuyue">
      <div style="position: relative;width: 430px;height: 503px;">
        <img src="@/assets/images/home/yuyue.svg" style="width: 430px;height: 503px;border-radius: 20px;"
          class="slide-image2 ">
        <img @click="isShowYuyue = false" src="@/assets/images/home/cancel.svg"
          style="width: 23px;height: 23px;object-fit: cover;" class=" yuyue-cancel curPot">
        <img src="@/assets/images/home/msg.svg" style="width: 30px;height: 25px;" class="slide-image  yuyue-msg  ">
        <div class="yuyue-title">关于身姿步态相关问题，请给我们留言</div>

        <div class="yuyue-from-info">
          <input type="text" placeholder="需要矫正人员年龄" v-model="translateInfo.age">
          <input type="text" placeholder="您的姓名" v-model="translateInfo.name">
          <input type="text" placeholder="手机号" v-model="translateInfo.phone">
          <input type="text" placeholder="所在城市" v-model="translateInfo.city">
          <input type="text" placeholder="留言内容" v-model="translateInfo.symptom">
          <div class="actOk" @click="handleYUyue">提 交</div>
        </div>
      </div>
    </div>
    <div class="home-container ">
      <div class="swiper-container ">
        <swiper     @slideChange="onSlideChange"
 :options="swiperOptions" ref="mySwiper">
          <swiper-slide v-for="(slide, index) in slides" :key="index">
            <div class="slide-content">
              <img :src="slide.image" :alt="slide.title" class="slide-image2">
              <div class="banxin" style="z-index: 99;">

                <div class="slide-caption">
                  <h3 class="title">{{ slide.title }}</h3>
                  <p class="description">{{ slide.description }}</p>
                  <button class="action-btn">
                    了解更多
                  </button>
                </div>
                <div style="display: flex;position: absolute;bottom: 56px;  margin-left: 89px;cursor: pointer;align-items: center;">
                <span style="font-weight: bold;font-size: 20px;color: #FFFFFF;padding-right: 9px;">{{ index+1 }}</span>
                  <div style="width: 50px;height: 4px;background: #FFFFFF;border-radius: 2px;margin-right: -2px;"
                    
                    v-for="(item, p) in slides.length" :key="p" :style="{ background: currentIndex == p ? '#ffffff' : '#BBBBBB' }"></div>
                  <span style="font-weight: bold;font-size: 20px;color: #FFFFFF;padding-left: 9px;">{{ slides.length}}</span>

                </div>

                <!-- <div style="position: absolute;bottom: 46px;  margin-left: 89px;display: flex;align-items: center;">
                  <img @click="$refs.mySwiper.$swiper.slidePrev()" src="@/assets/images/home/left.svg"
                    class="slide-image curPot">
                  <img src="@/assets/images/home/line.svg" style="padding: 0 8px 0 29px;" class="slide-image">
                  <img @click="$refs.mySwiper.$swiper.slideNext()" src="@/assets/images/home/right.svg"
                    class="slide-image curPot">
                </div> -->
              </div>




            </div>
          </swiper-slide>

        </swiper>

      </div>
    </div>
    <div class="box-1" style="padding-top: 91px;">
      <div class="banxin">
        <div>
          <div class="title">
            关于呦步
          </div>
          <div class="describe">
            呦步定制 · 专业守护每一步
          </div>
          <div class="title-en">
            About YoBu
          </div>
        </div>
        <div @click="handleNav('/about')">
          <div style="display: flex;margin-top: 24px;">
            <div style="position: relative;flex: 1;margin-top: 31px;">
              <img src="https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E8%B6%B3%E5%BD%A2%E6%98%BE%E7%A4%BA%E5%99%A8%E7%9A%84%E5%89%AF%E6%9C%AC.png
" style="width: 600px;height: 398px;position: absolute;top: 0;z-index: 2;" class="slide-image   ">
              <img src="@/assets/images/home/box1-2.png"
                style="width: 608px;height: 251px;position: absolute;top: 262px;margin-left: 67px;z-index: 1;"
                class="slide-image   ">
            </div>

            <div style="width: 500px;">
              <div style="font-weight: 600;font-size: 24px;color: #333333;">
                放心产品 · 用心服务
              </div>
              <div style="font-weight: 400;font-size: 14px;color: #333333;line-height: 42px;margin-top: 28px; ">
                呦步数字科技(北京)有限公司旗下「步足脊健康生物力学中心」，致力于引进国外先进的技术和经验，
                集足部及下肢生物力线为一体的专业化力学研究，应用3D数字技术开展足脊健康物理、
                物理干预及个性化定制服务，中心运用行业内先进的生物力学测量评估设备，配备专业足踝工程师，
                提供足脊健康讲座、健康筛查、健康干预、健康管理等系列服务项目，通过全面评估足脊健康水平，
                采用个性化定制生物力学辅具，切实调整和改善人体异常生物力线，重塑足型、调整步态、缓解和远离因生物力线引发的代偿性疼痛和不适。
              </div>
              <div style="position: relative;">
                <div style="width: 214px;height: 64px;position: absolute;bottom: -190px;right: 0;" class="curPot">
                  <img src="@/assets/images/home/moreBg.svg" style="width: 214px;height: 64px;" class="slide-image   ">
                  <div
                    style="font-weight: 500;color: #FFFFFF;font-size: 18px; position: absolute;top: 21px;left: 19px;">
                    View More
                  </div>
                  <img src="@/assets/images/home/moreRight.svg"
                    style="width: 20px;height: 11px;position: absolute;bottom: 10px;right: 52px;"
                    class="slide-image   ">
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>

    </div>



    <div class="box-2 ">

      <div class="banxin" style="  display: flex;justify-content: space-between;  ">
        <div>
          <div class="title">
            主营产品系列
          </div>
          <div class="describe">
            呦步定制 · 专业守护每一步
          </div>
          <div class="title-en">
            Main product series
          </div>
        </div>

        <div style="position: relative;" @click="handleNav('/products')">
          <img src="@/assets/images/home/moreBg.svg" style="width: 214px;height: 64px;" class="slide-image   ">
          <div style="font-weight: 500;color: #FFFFFF;font-size: 18px; position: absolute;top: 21px;left: 19px;"
            class="curPot">
            View More
          </div>
          <img src="@/assets/images/home/moreRight.svg"
            style="width: 20px;height: 11px;position: absolute;top: 43px;right: 52px;" class="slide-image   ">

        </div>
      </div>


      <div style="padding-top: 57px;display: flex;justify-content: space-between;" class="banxin">
        <div v-for="(item, index) in goodList" :key="index" style="position: relative;height: 402px;"
          @click="handleNav(item.url)">
          <div style="display: flex;flex-direction: column;">
            <img :src="item.img" style="width: 382px;height: 288px;" class="slide-image3">
            <img src="@/assets/images/good/goodBottom.png" style="width: 382px;height: 100px;" class="slide-image ">
            <div style="position: absolute;bottom: 50px;left: 27px;font-weight: 600;font-size: 20px;color: #FFFFFF;">
              {{ item.name }}
            </div>
            <img src="@/assets/images/home/moreRight.svg"
              style="width: 45px;height: 24px;position: absolute;bottom: 50px;right: 26px;"
              class="slide-image curPot  ">
          </div>
        </div>

      </div>
    </div>



    <div class="box-3 ">

      <div class="banxin" style="  display: flex;justify-content: space-between;   ">
        <div>
          <div class="title">
            足踝健康科普
          </div>
          <div class="describe">
            呦步定制 · 专业守护每一步
          </div>
          <div class="title-en">
            Ankle Health Science Popularization
          </div>
        </div>

        <div style="position: relative;" @click="handleNav('/knowledge')">
          <img src="@/assets/images/home/moreBg.svg" style="width: 214px;height: 64px;" class="slide-image   ">
          <div style="font-weight: 500;color: #FFFFFF;font-size: 18px; position: absolute;top: 21px;left: 19px;"
            class="curPot">
            View More
          </div>
          <img src="@/assets/images/home/moreRight.svg"
            style="width: 20px;height: 11px;position: absolute;top: 43px;right: 52px;" class="slide-image   ">

        </div>
      </div>


      <div style="padding-top: 45px;display: flex;justify-content: space-between;flex-wrap: wrap;gap: 24px;"
        class="banxin">
        <div v-for="(item, index) in footList" :key="index">
          <div style="display: flex;flex-direction: column;text-align: center;flex: 1;">
            <img :src="item.img" style="width: 178px;height: 178px;" class="slide-image3">
            <div @click="handleNav('/knowledge?index=' + index)" class="foot-hover-pub">{{ item.name }}</div>
          </div>
        </div>

      </div>
    </div>

    <div class="box-4 ">

      <div class="banxin" style="  display: flex;justify-content: space-between;    ">
        <div>
          <div class="title">
            应用场景
          </div>
          <div class="describe">
           呦步定制 · 专业守护每一步
          </div>
          <div class="title-en">
            Application scenario
          </div>
        </div>
        <div style="position: relative;" @click="handleNav('/scenarios')">
          <img src="@/assets/images/home/moreBg.svg" style="width: 214px;height: 64px;" class="slide-image   ">
          <div style="font-weight: 500;color: #FFFFFF;font-size: 18px; position: absolute;top: 21px;left: 19px;"
            class="curPot">
            View More
          </div>
          <img src="@/assets/images/home/moreRight.svg"
            style="width: 20px;height: 11px;position: absolute;top: 43px;right: 52px;" class="slide-image   ">

        </div>
      </div>
      <div style="display: flex;" class="banxin">
        <div
          style="padding-top: 45px;font-weight: bold;font-size: 40px;color: #333333;line-height: 56px;padding-right: 125px;">
          <div style="">
            量身定制
          </div>
          <div>
            每一步都精准支撑
          </div>


        </div>


        <div style="position: relative;width: 755px;height: 496px;box-sizing: border-box;">
          <el-carousel @change="handleCarouselChange" ref="myCarousel" height="496px" indicator-position="none" arrow="never" :interval="2500">
            <el-carousel-item v-for="(item,pp) in applicationList" :key="pp">
              <img :src="item.img" style="width: 755px;height: 496px;">
              <img src="@/assets/images/home/applicationbt.png"
                style="width: 755px;height: 149px;position: absolute;bottom: 0;left: 0;object-fit: cover;">
              <div style="position: absolute;bottom: 59px;left: 26px;font-weight: 600;font-size: 24px;color: #FFFFFF;">
                {{ item.name }}</div>
            </el-carousel-item>
          </el-carousel>
          <!-- <div v-for="(item, index) in applicationList" :key="index" v-show="applicationIndex == index">
            <img :src="item.img" style="width: 755px;height: 496px;">
            <img src="@/assets/images/home/applicationbt.png"
              style="width: 755px;height: 149px;position: absolute;bottom: 0;left: 0;">
            <div style="position: absolute;bottom: 59px;left: 26px;font-weight: 600;font-size: 24px;color: #FFFFFF;">
              {{ item.name }}</div>
          </div> -->

        </div>

      </div>
      <div class="banxin" style="padding-top: 73px;display: flex;align-items: center;cursor: pointer;">
        <div style="display: flex;">
          <div @click="handleApplicationIndex('-')"
            style="position: relative;display: flex;align-items: center;justify-content: center;width: 81px; height: 53px;border: 1px solid #333333;border-top-left-radius: 50px;border-bottom-left-radius: 50px;">
            <img src="@/assets/images/home/appLeft.svg" style="width: 19px;height: 14px" class="slide-image3">
          </div>

          <div @click="handleApplicationIndex('+')"
            style="position: relative;display: flex;align-items: center;justify-content: center;width: 81px; height: 53px;  border-style: solid;border-color: #333333;  border-width: 1px 1px 1px 0px; border-top-right-radius: 50px;border-bottom-right-radius: 50px;">
            <img src="@/assets/images/home/appRight.svg" style="width: 19px;height: 14px;" class="slide-image3">
          </div>


        </div>
        <div style="opacity: 0.68;font-weight: 600;font-size: 24px;color: #333333;padding: 0 30px;">{{ applicationIndex
          +
          1 }}/{{ applicationList.length }}</div>
        <div style="display: flex;">
          <div style="width: 50px;height: 4px;background: #FFFFFF;border-radius: 2px;margin-right: -2px;"
            :style="{ background: applicationIndex == index ? '#ffffff' : '#BBBBBB' }"
            v-for="(item, index) in applicationList.length" :key="index"></div>




        </div>
      </div>
    </div>





    <div class="box-5 ">

      <div class="banxin" style="  display: flex;justify-content: space-between;    ">
        <div>
          <div class="title">
            一站式定制

          </div>
          <div class="describe">
            呦步定制 · 专业守护每一步
          </div>
          <div class="title-en">
            One stop customizati
          </div>
        </div>
        <div style="position: relative;" @click="handleNav('/customization')">
          <img src="@/assets/images/home/moreBg.svg" style="width: 214px;height: 64px;" class="slide-image   ">
          <div style="font-weight: 500;color: #FFFFFF;font-size: 18px; position: absolute;top: 21px;left: 19px;"
            class="curPot">
            View More
          </div>
          <img src="@/assets/images/home/moreRight.svg"
            style="width: 20px;height: 11px;position: absolute;top: 43px;right: 52px;" class="slide-image   ">

        </div>
      </div>


      <div class="banxin" style="margin-top: 80px;">
        <div style="display: flex;justify-content: space-between;gap: 6px;">
          <div @click="handleNav('/customization?id=' + index)" v-for="(item, index) in divList" :key="index"
            class="hover-gradient-container" :style="'background-image: url(' + item.bgImg + ');'">
            <div style="padding: 67px 0 26px 28px;display: flex;flex-direction: column;height: 100%;">
              <img :src="item.icon" style="width: 50px;height: 50px;object-fit: contain;" alt="">
              <div style="font-weight: 600;font-size: 20px;color: #FFFFFF;padding-top: 33px;flex: 1;">{{ item.name }}
              </div>
              <div style="display: flex;gap: 21px;align-items: center;">
                <div style="font-weight: 600;font-size: 24px;color: #FFFFFF;">0{{ index + 1 }}</div>
                <img src="@/assets/images/index/right.png" style="width: 48px;height: 13px;object-fit: contain;" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="box-6 ">

      <div class="banxin" style="  display: flex;justify-content: space-between; ">
        <div>
          <div class="title">
            新闻活动
          </div>
          <div class="describe">
            呦步定制 · 专业守护每一步
          </div>
          <div class="title-en">
            News and Events
          </div>
        </div>
        <div style="position: relative;" @click="handleNav('/news')">
          <img src="@/assets/images/home/moreBg.svg" style="width: 214px;height: 64px;" class="slide-image   ">
          <div style="font-weight: 500;color: #FFFFFF;font-size: 18px; position: absolute;top: 21px;left: 19px;"
            class="curPot">
            View More
          </div>
          <img src="@/assets/images/home/moreRight.svg"
            style="width: 20px;height: 11px;position: absolute;top: 43px;right: 52px;" class="slide-image   ">

        </div>
      </div>
      <div class="banxin" style="margin-top: 62px;">

        <el-row :gutter="20">
          <el-col :span="16">
            <el-carousel height="439px" style="width: 800px;" arrow="never" indicator-position="none">
              <!-- 设置宽度为 800px -->
              <el-carousel-item v-for="(item, index) in newList" :key="index">
                <div style="display: flex; height: 439px; align-items: flex-end;position: relative;">
                  <!-- 动态背景图 -->
                  <div :style="{ backgroundImage: 'url(' + require('@/assets/images/index/9527.png') + ')' }"
                    style="z-index: 999;;width: 92px; height: 108px; display: flex; flex-direction: column; gap: 13px; align-items: center; justify-content: center; font-weight: bold; color: #FFFFFF;">
                    <div style="font-size: 24px;">{{ splitDate(item.time).day }}</div>
                    <div style="font-size: 18px;">{{ splitDate(item.time).yearMonth }}</div>
                  </div>

                  <!-- 轮播图片 -->
                  <img :src="item.img" style="height: 439px; width: 707px;" class="slide-image">
                  <div @click="handleNav(item.url)"
                    style="cursor: pointer;font-weight: 500;font-size: 15px;color: #FFFFFF;;padding-left: 26px;position: absolute;bottom: 0;right: 0;width: 707px;;background: rgba(40, 40, 40, 0.3);height: 58px;line-height: 58px;">
                    {{ item.title }}</div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </el-col>
          <el-col :span="8">
            <div
              style="background: #000;height: 439px;padding: 56px 23px 55px 22px;display: flex;flex-direction: column;gap: 28px;">
              <div @click="handleNav(item.url)" v-for="(item, index) in newList" :key="index"
                style="color: #fff;cursor: pointer;">
                <div style="font-weight: 500;font-size: 14px;color: #FFFFFF;">{{ item.time }}</div>

                <div style="display: flex;justify-content: space-between;">
                  <div class="ellipsis" style="width: 261px;;font-weight: 400;font-size: 14px;color: #FFFFFF;">{{
                    item.title }}</div>

                  <div style="display: flex;align-items: center;gap: 8px;">
                    <div style="font-weight: 400;font-size: 12px;color: #FFFFFF;">查看详情</div>
                    <img src="@/assets/images/index/right2.png" style="height: 15px; width: 8px;object-fit: contain;">
                  </div>
                </div>

              </div>
            </div>

          </el-col>

        </el-row>
        <div></div>


      </div>

    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// import myHeader from '@/components/header.vue'
import axios from 'axios';

export default {
  name: 'Home',
  components: {
    Swiper,
    SwiperSlide,
    // myHeader
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  mounted() {
    // 可以在这里调用swiper实例方法
    console.log('Current Swiper instance object', this.swiper)

  },
  created() {
    this.isShowYuyue = JSON.parse(window.localStorage.getItem("isShowYuyue")) == false ? false : true;
  },
  /**
   * 返回组件的数据对象。
   *
   * @returns 返回包含组件所需数据的对象。
   */
  data() {
    return {
      newList: [
        {
          title: '呦步走进南磨房社区-足部健康科普行，守护每一步幸福',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/ce247ae20394888de780b96292acb182.jpeg',
          url: 'https://mp.weixin.qq.com/s/kTJHUF3_aX4Cs9iWelNN7Q',
          time: '2025-05-18'
        },
        {
          title: '校企合作丨开启足踝健康未来职业新赛道',
          url: 'https://mp.weixin.qq.com/s/RbtIcxZBvnBBtozbCnF1fg',

          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/d8207a4166ccad6bdba11549670acd47.jpeg',
          time: '2024-12-07'
        },
        {
          title: '小脚丫，大未来丨共筑青少年“呦美”步态',
          url: 'https://mp.weixin.qq.com/s/UEAtf7wf-nuUOyYeObIEfQ',

          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/73a76a144d545114754881ed3754fd54.jpeg',
          time: '2024-11-19'
        },
        {
          title: '呦步3D生物力学技术，助力山西男篮新赛季',
          url: 'https://mp.weixin.qq.com/s/kTJHUF3_aX4Cs9iWelNN7Q',

          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/d0ba3473993d1956730e47ddaf63abb5.jpeg',
          time: '2024-09-30'
        },
        {
          title: '做“足”准备，“踝”抱健康——呦步走进北京体育大学开展足部健康筛查活动',
          url: 'https://mp.weixin.qq.com/s/ns0nnfqeJOppPtvwCsAJKQ',

          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/a677f72c763698e1c3b170718e241f59.jpeg',
          time: '2024-06-29'
        }],



      applicationIndex: 0,
      applicationList: [
        {
          name: '青少年儿童足脊步态矫正干预',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/d9c72d555a15c2cd7c2b6bdb8977e32d.jpeg',
        },
        {
          name: '足膝腰脊力线调整｜疼痛干预与防护',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/c3d748e08e04fa09bd707c289153ad87.jpeg',
        },
        {
          name: '双下肢不等长的预防与干预措施',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/e4d6b61e876985ec8d07fd1c98cbc3e5.jpeg',
        },
        {
          name: '运动专项防护与运动表现提升',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E5%BA%94%E7%94%A8%E5%9C%BA%E6%99%AF%E5%9B%BE3%403x.png',
        }
      ],
      footList: [
        {

          name: '- 扁平足 -',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E6%89%81%E5%B9%B3%E8%B6%B3.jpeg',
        },
        {
          name: '- 高弓足 -',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E9%AB%98%E5%BC%93%E8%B6%B3.jpeg',
        },
        {

          name: '- 拇外翻 -',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E6%8B%87%E5%A4%96%E7%BF%BB.jpeg',
        }
        ,
        {

          name: '- 副舟骨 -',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E5%89%AF%E8%88%9F%E9%AA%A8.jpeg',
        }
        ,
        {

          name: '- 跖骨痛 -',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E8%B7%96%E9%AA%A8%E7%97%9B.jpeg',
        }
        ,
        {

          name: '- 足底筋膜炎 -',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E8%B6%B3%E5%BA%95%E9%A2%88%E8%86%9C%E7%82%8E.jpeg',
        }
        ,
        {

          name: '- 习惯性崴脚 -',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E6%8D%A2%E6%96%B0-%E4%B9%A0%E6%83%AF%E6%80%A7%E5%B4%B4%E8%84%9A.png',
        }
        ,
        {

          name: '- 内八字 -',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E6%8D%A2%E6%96%B0-%E5%86%85%E5%85%AB%E5%AD%97.png',
        },
        {

          name: '- 外八字 -',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E6%8D%A2%E6%96%B0-%E5%A4%96%E5%85%AB%E5%AD%97.png',
        },
        {

          name: '- X型腿 -',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/X%E5%9E%8B%E8%85%BF.jpeg',
        },
        {

          name: '- O型腿 -',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/O%E5%9E%8B%E8%85%BF.jpeg',
        },
        {

          name: '- 长短腿 -',
          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E9%95%BF%E7%9F%AD%E8%85%BF.jpeg',
        }
      ],
      divList: [
        {
          name: '数字化检测评估流程',
          bgImg: require('@/assets/images/index/1.png'),
          icon: require('@/assets/images/index/icon1.png'),
        },
        {
          name: '一站式数字化定制服务',
          bgImg: require('@/assets/images/index/2.png'),
          icon: require('@/assets/images/index/icon2.png'),
        },
        {
          name: '支撑远程定制服务',
          bgImg: require('@/assets/images/index/3.png'),
          icon: require('@/assets/images/index/icon3.png'),
        },
        {
          name: '售后服务保障',
          bgImg: require('@/assets/images/index/4.png'),
          icon: require('@/assets/images/index/icon4.png'),
        }
      ],
      goodList: [
        {
          goodId: 1,
          name: '3D打印足弓垫',
          url: 'detail?goodId=1',

          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/aed3028395b88c57188cc8a404f3f9e9.jpeg',
        },
        {
          goodId: 2,
          name: '国产雕刻足弓垫',
          url: 'detail?goodId=2',

          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/f1d52900d143733fb0e0a141ede8a9d9.jpeg',
        },
        {
          goodId: 3,
          name: '进口雕刻足弓垫',
          url: 'detail?goodId=3',

          img: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/3e52f27c28f5f7a95493a4ab7478a631.jpeg',
        }
      ],
      translateInfo: {},
      isShowYuyue: true,
      
            currentIndex: 0,

      slides: [
        {
          image: require('@/assets/images/home/banner1.png'),
          title: '呦步足下 健康随行',
          description: 'YOBU UDERFOOTING HEALTH ACCACCOMPANYING',
        },
        {
          image: 'https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E9%A6%96%E9%A1%B5banner.png',
          title: '关于呦步',
          description: '足脊健康数字化检测评估 3D数字生物力学',
        },
        {
          image: require('@/assets/images/home/banner3.png'),
          title: '呦步更专业、更准确、更高效',
          description: '国际先进足部检测系统 ·数字化分析评估系统·个性化全贴合设计定制 ·引进国际制造工艺',
        }
      ],
      swiperOptions: {
        // 基础配置
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        speed: 1200,

        // 分页器
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },

        // 导航按钮
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },

        // 效果
        effect: 'fade', // 淡入淡出效果
        fadeEffect: {
          crossFade: true
        }
      }
    }
  },
   watch: {
    // currentIndex(newVal) {
    //   if (this.$refs.mySwiper) {
    //     this.$refs.mySwiper.swiper.slideTo(newVal);
    //   }
    // }
  },
  methods: {
      handleCarouselChange(currentIndex) {
      this.applicationIndex = currentIndex;

    },
    onSlideChange(){
            const activeIndex = this.$refs.mySwiper.$swiper.realIndex;
            this.currentIndex = activeIndex
    },

    async handleYUyue() {

      this.translateInfo.age = Number(this.translateInfo.age)
      let translateInfo = this.translateInfo

      if (!translateInfo.name || !translateInfo.phone || !translateInfo.city || !translateInfo.age) {
        this.$notify({
          title: '温馨提示',
          message: '存在未填写数据',
          type: 'error'
        });
        return
      }
      window.localStorage.setItem("isShowYuyue", false)
      this.isShowYuyue = false
      await axios.post('https://api.yo-bu.com/api/next/appointment/add', this.translateInfo, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      window.localStorage.setItem('isShowYuyue', false)
      this.$notify({
        title: '预约成功',
        message: '恭喜你，预约成功,请等待工作人员联系你~~',
        type: 'success'
      });


    },


    splitDate(dateString) {
      // 使用 split 方法将日期字符串分割为数组
      const parts = dateString.split('-');

      // 确保日期字符串格式正确
      if (parts.length !== 3) {
        throw new Error('Invalid date format. Expected format: YYYY-MM-DD');
      }

      // 拼接年份和月份
      const yearMonth = parts[0] + '-' + parts[1];
      // 获取日期
      const day = parts[2];

      // 返回结果
      return {
        yearMonth: yearMonth,
        day: day
      };
    },
    handleNav(url) {
      if (url.indexOf('http') != -1) {
        window.open(url)
      } else {
        this.$router.push(url)
      }

    },
    handleApplicationIndex(type) {
      let index = this.applicationIndex
      if (type == '+') {
        if (index == this.applicationList.length - 1) {
          this.applicationIndex = 0
        } else {
          this.applicationIndex = index + 1
          this.$refs.myCarousel.next();

        }
      } else {
        if (index == 0) {
          this.applicationIndex = this.applicationList.length - 1
          this.$refs.myCarousel.prev();

        } else {
          this.applicationIndex = index - 1
          this.$refs.myCarousel.prev();

        }
      }
    }
  },
  metaInfo: {
    title: '呦步 - 首页',
    meta: [
      {
        name: 'description',
        content: ''
      },
      {
        name: 'keywords',
        content: ''
      }
    ]
  }
}

</script>
<style scoped lang="scss">
@import "@/assets/scss/functions.scss";

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.foot-hover-pub {
  margin-top: -10px;
  height: 77px;
  line-height: 77px;
  background: #F5F5F5;
  box-shadow: 0px 2px 4px 0px rgba(201, 201, 201, 0.5);
  border: 1px solid #F5F5F5;
  font-weight: 600;
  font-size: 18px;
  color: #333333;
}

.foot-hover-pub:hover {
  margin-top: -10px;
  height: 77px;
  line-height: 77px;
  background: #FC5F10;
  box-shadow: 0px 2px 4px 0px rgba(201, 201, 201, 0.5);
  border: 1px solid #F5F5F5;
  font-weight: 600;
  font-size: 18px;
  color: #FFFFFF;
  cursor: pointer;
}

.box-1 {
  width: 100%;
  height: 897px; // 确保高度与图片一致

  background-image: url('@/assets/images/home/about.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .title {
    font-weight: 800;
    font-size: 35px;
    color: #333333;
  }

  .describe {
    // padding-top: 38px;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
  }

  .title-en {
    padding-top: 20px;

    font-family: HelveticaNeue, HelveticaNeue;
    font-weight: bold;
    font-size: 30px;

    /* 渐变效果 */
    background: linear-gradient(318.87deg, #FC5F10 0%, #FFA949 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;

    /* 确保渐变方向正确 */
    display: inline-block;
    /* 对于某些浏览器需要这个属性 */
  }
}

.box-2 {
  // position: relative;
  width: 100%;
  height: 788px; // 确保高度与图片一致
  padding-top: 91px;
  background-image: url('@/assets/images/home/about1.png');
    background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .title {
    font-weight: 800;
    font-size: 35px;
    color: #333333;
  }

  .describe {
    // padding-top: 38px;

    font-weight: 400;
    font-size: 20px;
    color: #333333;
  }

  .title-en {
    padding-top: 20px;

    font-family: HelveticaNeue, HelveticaNeue;
    font-weight: bold;
    font-size: 30px;

    /* 渐变效果 */
    background: linear-gradient(318.87deg, #FC5F10 0%, #FFA949 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;

    /* 确保渐变方向正确 */
    display: inline-block;
    /* 对于某些浏览器需要这个属性 */
  }
}

.box-3 {
  // position: relative;
  width: 100%;
  height: 985px; // 确保高度与图片一致
  padding-top: 156px;
  background-image: url('@/assets/images/home/about3.png');
   background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .title {
    font-weight: 800;
    font-size: 35px;
    color: #333333;
  }

  .describe {
    // padding-top: 38px;

    font-weight: 400;
    font-size: 20px;
    color: #333333;
  }

  .title-en {
    padding-top: 20px;

    font-family: HelveticaNeue, HelveticaNeue;
    font-weight: bold;
    font-size: 30px;

    /* 渐变效果 */
    background: linear-gradient(318.87deg, #FC5F10 0%, #FFA949 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;

    /* 确保渐变方向正确 */
    display: inline-block;
    /* 对于某些浏览器需要这个属性 */
  }
}

.box-4 {
  // position: relative;
  width: 100%;
  height: 1064px; // 确保高度与图片一致
  padding-top: 91px;
  background-image: url('@/assets/images/home/about4.png');
    background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .title {
    font-weight: 800;
    font-size: 35px;
    color: #333333;
  }

  .describe {
    // padding-top: 38px;

    font-weight: 400;
    font-size: 20px;
    color: #333333;
  }

  .title-en {
    padding-top: 20px;

    font-family: HelveticaNeue, HelveticaNeue;
    font-weight: bold;
    font-size: 30px;

    /* 渐变效果 */
    background: linear-gradient(318.87deg, #FC5F10 0%, #FFA949 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;

    /* 确保渐变方向正确 */
    display: inline-block;
    /* 对于某些浏览器需要这个属性 */
  }
}

.box-5 {
  // position: relative;
  width: 100%;
  height: 854px; // 确保高度与图片一致
  padding-top: 91px;
  background-image: url('@/assets/images/home/about5.png');
     background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .title {
    font-weight: 800;
    font-size: 35px;
    color: #333333;
  }

  .describe {
    // padding-top: 38px;

    font-weight: 400;
    font-size: 20px;
    color: #333333;
  }

  .title-en {
    padding-top: 20px;

    font-family: HelveticaNeue, HelveticaNeue;
    font-weight: bold;
    font-size: 30px;

    /* 渐变效果 */
    background: linear-gradient(318.87deg, #FC5F10 0%, #FFA949 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;

    /* 确保渐变方向正确 */
    display: inline-block;
    /* 对于某些浏览器需要这个属性 */
  }
}

.box-6 {
  // position: relative;
  width: 100%;
  height: 814px; // 确保高度与图片一致
  padding-top: 91px;

  background-image: url('@/assets/images/home/about6.png');
     background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .title {
    font-weight: 800;
    font-size: 35px;
    color: #333333;
  }

  .describe {
    // padding-top: 38px;

    font-weight: 400;
    font-size: 20px;
    color: #333333;
  }

  .title-en {
    padding-top: 20px;

    font-family: HelveticaNeue, HelveticaNeue;
    font-weight: bold;
    font-size: 30px;

    /* 渐变效果 */
    background: linear-gradient(318.87deg, #FC5F10 0%, #FFA949 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;

    /* 确保渐变方向正确 */
    display: inline-block;
    /* 对于某些浏览器需要这个属性 */
  }
}

// .box-1-title{
//     position: absolute;
//     top: 120px;
//     font-weight: 800;
//     font-size: 35px;
//     color: #333333;
//     font-weight: 800;
//     font-size: 60px;
//     color: #FFFFFF;
//     z-index: 999;
//   }
.yuyue {
  z-index: 999;
  position: fixed;
  right: 48px;
  top: 180px;
  // bottom: 26px;
  // background-color: #FFFFFF;
}

.yuyue-cancel {
  position: absolute;
  right: 9px;
  top: 9px;
}

.yuyue-msg {
  position: absolute;
  left: 10px;
  top: 20px;
}

.yuyue-from-info {
  position: absolute;
  right: 22px;
  top: 75px;
  display: flex;
  flex-direction: column;
  gap: 23px;
}

.yuyue-from-info input {
  width: 387px;
  height: 50px;
  border-radius: 10px;
  border: 1px solid #E3E3E3;
  font-weight: 500;
  padding-left: 30px;
  font-size: 18px;
  color: #999999;
}

.yuyue-from-info input:focus {
  outline: none;
  /* 移除默认蓝色轮廓 */
  border-color: #ddd;
  /* 保持原边框颜色 */
  box-shadow: none;
  padding-left: 30px;

  /* 移除发光效果 */
}

.yuyue-from-info input::placeholder {

  // padding-left: 30px;
  /* 可调整右边距 */

}

.yuyue-title {
  position: absolute;
  left: 50px;
  top: 20px;
  font-weight: 500;
  font-size: 18px;
  color: #FFFFFF;
}

// .home-container {
//   padding-top: 138px;
// }

.swiper-container {
  // position: relative;
  width: 100%;
  height: 718px;
  /* 根据设计调整 */
}

.slide-content {
  position: relative;
  width: 100%;
  height: 718px;
}


.slide-caption {
  position: absolute;
  bottom: 232px;
  margin-left: 83px;
  color: white;

  // padding: 30px;
  // border-radius: 8px;
}

.title {
  font-weight: 800;
  font-size: 60px;
  color: #FFFFFF;
  margin-bottom: 19px;
}

.description {
  font-weight: 800;
  font-size: 20px;
  color: #FFFFFF;
  margin-bottom: 41px;
}

.action-btn {
  font-weight: 800;
  background: linear-gradient(49deg, #FC5F10 0%, #FFA949 100%);
  color: white;
  border: none;
  font-size: 16px;
  padding: 14px 28px;
  font-size: 16px;
  border-radius: 25px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.3s;
}

.actOk {
  font-weight: 800;
  background: linear-gradient(49deg, #FC5F10 0%, #FFA949 100%);
  color: white;
  border: none;
  font-size: 16px;
  width: 117px;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  border-radius: 10px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
}

.actOk:hover {
  background: #e0550d;
}

.action-btn:hover {
  background: #e0550d;
}

.hover-gradient-container {
  cursor: pointer;
  width: 295px;
  height: 482px;
  position: relative;
  overflow: hidden;
  /* 确保伪元素不溢出 */
  background-size: cover;
  background-position: center;
  transition: all 0.5s ease;
  /* 平滑过渡 */
}

/* 渐变覆盖层（左下到右上） */
.hover-gradient-container::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to left top,
      /* 从左下到右上的方向 */
      #FC5F10 0%,
      /* 起始颜色（可调整透明度） */
      transparent 100%
      /* 结束透明 */
    );
  opacity: 0;
  /* 默认隐藏 */
  transition: opacity 0.5s ease;
}

/* 悬停时显示渐变层 */
.hover-gradient-container:hover::before {
  opacity: 1;
}

/* 悬停时内容放大效果（可选） */
.hover-gradient-container:hover {
  transform: scale(1.02);
}

/* 自定义分页器样式 */
// .swiper-pagination /deep/ .swiper-pagination-bullet {
//   background: white;
//   opacity: 0.6;
//   width: 12px;
//   height: 12px;
// }

// .swiper-pagination /deep/ .swiper-pagination-bullet-active {
//   background: #FC5F10;
//   opacity: 1;
// }

/* 导航按钮样式 */
// .swiper-button-prev,
// .swiper-button-next {
//   color: white;
//   background: rgba(0, 0, 0, 0.3);
//   width: 50px;
//   height: 50px;
//   border-radius: 50%;
//   transition: all 0.3s;
// }

// .swiper-button-prev:hover,
// .swiper-button-next:hover {
//   background: rgba(0, 0, 0, 0.6);
// }

// .swiper-button-prev::after,
// .swiper-button-next::after {
//   font-size: 1.5rem;
// }</style>